import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
    {
        path: '/officialholidays',
        name: 'OfficialHolidaysView',
        component: () => import(/* webpackChunkName: "officialholidays-view" */ '@/modules/official_holidays/components/OfficialHolidaysView'),
        meta: {
            moduleId: 'officialHolidays',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/officialholidays/:id',
        name: 'OfficialHolidaysForm',
        component: () => import(/* webpackChunkName: "officialholidays-form" */ '@/modules/official_holidays/components/OfficialHolidaysForm'),
        meta: { moduleId: 'officialHolidays' },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/officialholidayscalendar',
        name: 'OfficialHolidaysCalendarView',
        component: () => import(/* webpackChunkName: "officialholidayscalendar-view" */ '@/modules/official_holidays/components/calendar/OfficialHolidaysCalendar'),
        meta: {
            moduleId: 'officialHolidayCalendars',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        props: true,
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/officialholidayscalendar/:id',
        name: 'OfficialHolidaysCalendarForm',
        component: () => import(/* webpackChunkName: "officialholidayscalendar-form" */ '@/modules/official_holidays/components/calendar/OfficialHolidaysCalendarForm'),
        meta: { moduleId: 'officialHolidayCalendars' },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/states',
        name: 'OfficialHolidayState',
        component: () => import(/* webpackChunkName: "states-view" */ '@/modules/official_holidays/components/state/OfficialHolidaysState'),
        meta: {
            moduleId: 'states',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/states/:id',
        name: 'OfficialHolidaysStateForm',
        component: () => import(/* webpackChunkName: "states-form" */ '@/modules/official_holidays/components/state/OfficialHolidaysStateForm'),
        meta: { moduleId: 'states' },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
]
